import { render } from "./UserGroupShareSettings.vue?vue&type=template&id=fffb50d4&scoped=true&ts=true"
import script from "./UserGroupShareSettings.vue?vue&type=script&lang=ts"
export * from "./UserGroupShareSettings.vue?vue&type=script&lang=ts"

import "./UserGroupShareSettings.vue?vue&type=style&index=0&id=fffb50d4&scoped=true&lang=scss"

import exportComponent from "/home/appstore/appstore/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fffb50d4"]])

export default __exports__